import { DELETE, GET, POST, PUT } from "./_config";

//user
export const getConditionData = async (query) =>
  await GET(`/medical-conditions?${query || ""}`);

export const getConditionById = async (id) =>
  await GET(`/medical-conditions/get-condition/${id}`, true);

//admin
export const createConditionData = async (body) =>
  await POST("/medical-conditions/", body, true);

export const getConditionDataList = async (query) =>
  await GET(`/medical-conditions/list?${query || ""}`, true);

export const getConditionDataById = async (id) =>
  await GET(`/medical-conditions/${id}`, true);

export const updateConditionDataById = async (id, body) =>
  await PUT(`/medical-conditions?id=${id}`, body, true);

export const deleteConditionDataById = async (id) =>
  await DELETE(`/medical-conditions?id=${id}`, true);

export const updateConditionStatus = async (body) =>
  await POST("/medical-conditions/update-status", body, true);

export const updateMedicalConditionSortOrders = async (payload) =>
  await PUT("medical-conditions/sort-order", { sortOrders: payload }, true);
